import React, { useState } from "react";
import Bannerupdate from "../Component/Bannerupdate";
import "../Style/Pages/Bannerandreviews.css";
import CustomerReviews from "../Component/CustomerReviews";
import Splashscreen from "../Component/Splashscreen";

const BannerandReviews = () => {
  const [curr, setCurr] = useState("banner"); // UI state only

  return (
    <div className="bannerandreviews">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "2vh",
        }}
      >
        <span
          className="bannertitle"
          style={{
            color: curr !== "banner" ? "grey" : "var(--primary)",
            cursor: "pointer",
          }}
          onClick={() => setCurr("banner")}
        >
          Banner Update
        </span>

        <span
          className="bannertitle"
          style={{
            color: curr === "banner" ? "grey" : "var(--primary)",
            marginLeft: "20px",
            cursor: "pointer",
          }}
          onClick={() => setCurr("review")}
        >
          Customer Reviews
        </span>
      </div>

      {curr === "banner" ? (
        <Bannerupdate />
      ) : (
        <div className="reviewsplash">
          <Splashscreen />
          <CustomerReviews />
        </div>
      )}
    </div>
  );
};

export default BannerandReviews;
